export default __webpack_public_path__ + "aa4dd24cb264f64a249adf33b64efa88.png";